export const checkListNodes = {
    check_list: {
        group: "block",
        content: "check_list_item+",
        parseDOM: [
            {
                tag: "ul.checklist",
                attrs: { class: "checklist" },
            },
        ],
        toDOM() {
            return ["ul", { class: "checklist" }, 0];
        },
    },
    check_list_item: {
        content: "paragraph+",
        attrs: {
            checked: { default: false },
        },
        parseDOM: [
            {
                tag: "li.checklist-item",
                getAttrs: (element) => {
                    return {
                        checked: element.classList.contains("checklist-item-complete"),
                        class: "checklist-item",
                    };
                },
            },
        ],
        toDOM: (node) => {
            const attrs = node.attrs;
            return [
                "li",
                {
                    class: `checklist-item ${attrs.checked ? "checklist-item-complete" : ""}`,
                },
                [
                    "label",
                    {
                        class: "check-box-item-label",
                        contenteditable: "false",
                    },
                    [
                        "input",
                        {
                            class: "checklist-item-checkbox",
                            type: "checkbox",
                            contenteditable: "false",
                            checked: attrs.checked.toString(),
                        },
                    ],
                    [
                        "span",
                        {
                            class: "check-box-item-icon",
                            contenteditable: "false",
                        },
                    ],
                ],
                ["div", { class: "checklist-item-content" }, 0],
            ];
        },
    },
};
